export { default } from './SanityRichText'
